import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "emitter.icon",
  "use": "emitter.icon-usage",
  "viewBox": "0 0 19.867 21.943",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.867 21.943\" id=\"emitter.icon\"><defs><style>#emitter.icon .cls-1{fill:#426882}</style></defs><g id=\"emitter.icon_Group_1996\" data-name=\"Group 1996\" transform=\"translate(-989 -249.5)\"><path id=\"emitter.icon_Subtraction_196\" data-name=\"Subtraction 196\" class=\"cls-1\" d=\"M5.418,9.933H3.612a6.321,6.321,0,1,1,12.643,0H14.448a4.515,4.515,0,1,0-9.03,0Zm-3.612,0H0a9.933,9.933,0,0,1,19.866,0H18.06a8.127,8.127,0,0,0-16.254,0Z\" transform=\"translate(989 249.5)\" /><g id=\"emitter.icon_Group_1967\" data-name=\"Group 1967\" transform=\"translate(996.239 256.513)\"><path id=\"emitter.icon_Rectangle_4918\" data-name=\"Rectangle 4918\" class=\"cls-1\" transform=\"translate(1.81 4.524)\" d=\"M0 0H1.81V10.406H0z\" /><circle id=\"emitter.icon_Ellipse_437\" data-name=\"Ellipse 437\" class=\"cls-1\" cx=\"2.715\" cy=\"2.715\" r=\"2.715\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/emitter.icon.svg
// module id = waPM
// module chunks = 13